import React from "react";
import {
  Modal,
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import DateTimePicker from "react-datetime-picker";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    width: 500,
    height: 500,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  item: {
    marginBottom: theme.spacing(3),
  },
  modalButtons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
}));

export default function AddModal({
  open,
  setOpen,
  handleSubmit,
  titleRef,
  color,
  setColor,
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd,
  loading,
}) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Container className={classes.modalContainer}>
        <Typography variant="h4" align="center" gutterBottom>
          Add to Calendar
        </Typography>
        <form onSubmit={handleSubmit}>
          <div className={classes.item}>
            <TextField
              label="Event Title"
              style={{ width: "100%" }}
              required
              inputRef={titleRef}
            />
          </div>
          <div className={classes.item}>
            <Typography variant="h5" gutterBottom>
              Start Date
            </Typography>
            <DateTimePicker
              value={dateStart}
              onChange={(nextDate) => setDateStart(nextDate)}
            />
          </div>
          <div className={classes.item}>
            <Typography variant="h5" gutterBottom>
              End Date
            </Typography>
            <DateTimePicker
              value={dateEnd}
              onChange={(nextDate) => setDateEnd(nextDate)}
            />
          </div>
          <div className={classes.item}>
            <TextField
              select
              label="Color"
              style={{ width: "100%" }}
              value={color}
              onChange={(event) => setColor(event.target.value)}
            >
              <MenuItem value="Blue">Blue</MenuItem>
              <MenuItem value="Green">Green</MenuItem>
              <MenuItem value="Purple">Purple</MenuItem>
              <MenuItem value="Red">Red</MenuItem>
            </TextField>
          </div>
          <div className={classes.modalButtons}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginRight: 10 }}
              disabled={loading}
            >
              Add Event
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Container>
    </Modal>
  );
}
